var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M12.455 1.042c-1.14 0-2.059 0-2.78.097-.751.1-1.383.316-1.884.818-.438.437-.659.975-.775 1.606-.112.614-.134 1.365-.139 2.267a.625.625 0 0 0 1.25.007c.005-.912.029-1.557.119-2.048.086-.472.226-.745.429-.948.23-.23.554-.381 1.166-.464.63-.084 1.463-.085 2.66-.085h.833c1.196 0 2.03 0 2.66.085.611.083.935.233 1.166.464.23.23.38.554.463 1.166.084.63.086 1.463.086 2.66v6.666c0 1.196-.002 2.03-.086 2.66-.082.612-.233.935-.463 1.166-.231.23-.555.381-1.166.463-.63.085-1.464.086-2.66.086H12.5c-1.197 0-2.03-.001-2.66-.086-.612-.082-.936-.232-1.166-.463-.203-.203-.343-.476-.43-.949-.09-.49-.113-1.136-.118-2.047a.625.625 0 1 0-1.25.007c.005.901.027 1.652.14 2.266.115.632.336 1.17.774 1.607.501.502 1.133.717 1.883.818.723.097 1.641.097 2.78.097h.926c1.14 0 2.058 0 2.78-.097.75-.1 1.382-.317 1.884-.818.501-.502.717-1.133.818-1.883.097-.723.097-1.641.097-2.781V6.62c0-1.14 0-2.058-.097-2.781-.101-.75-.317-1.382-.818-1.883-.502-.502-1.134-.718-1.884-.818-.722-.098-1.64-.098-2.78-.097z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M12.5 9.375a.625.625 0 1 1 0 1.25H3.355l1.633 1.4a.625.625 0 1 1-.813.95l-2.917-2.5a.625.625 0 0 1 0-.95l2.917-2.5a.625.625 0 1 1 .813.95l-1.633 1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.86b7975ebfa48a67a5d07d76c9e34ed9.svg";
export { ForwardRef as ReactComponent };